<template>
  <div class="w-100 makers-container" :style="makerStyle">
    <div class="container">
      <BRow class="w-100 align-items-center mt-5">
        <BCol v-for="(maker, index) in makers" :key="index" @click="changeMaker(index)">
          <div class="option">
            <prismic-rich-text
              :field="maker.title1"
              class="title-faq text-center w-100"
              :class="{ selected: isSelected(index) }"
            ></prismic-rich-text>
          </div>
          <div class="option-border" :class="{ 'selected-border': isSelected(index) }"></div>
        </BCol>
      </BRow>
    </div>

    <div class="container">
      <div class="row content-container">
        <div v-if="imageUrl" class="col-md-6 col-12 image-container">
          <BImgLazy
            :src="imageUrl"
            fluid
            :alt="makers[selectedMaker].image.alt"
            height="427"
            width="510"
          />
        </div>
        <div :class="{ 'col-md-6': imageUrl }" class="col-12">
          <BRow cols="1" class="w-100">
            <prismic-rich-text
              :field="makers[selectedMaker].description"
              class="makers-subtitle"
            ></prismic-rich-text>
            <BCol class="button see-more-button">
              <Button
                shape="outline"
                color="transparent"
                text="white"
                :blank="true"
                :to="makers[selectedMaker].button_link"
              >
                {{ makers[selectedMaker].button_text }}
              </Button>
            </BCol>
          </BRow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BImgLazy, BRow, BCol } from 'bootstrap-vue';
import Button from 'UI/Button';
import { mapGetters } from 'vuex';

export default {
  components: {
    BImgLazy,
    Button,
    BRow,
    BCol
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return { makers: [], selectedMaker: 0 };
  },
  computed: {
    ...mapGetters('experience', ['getExperience', 'getExperienceColor']),
    makerStyle() {
      return `
      transition: background-color 0.5s ease;
      background-color: ${
        this.makers[this.selectedMaker].background_color || this.getExperienceColor
      };
      `;
    },
    imageUrl() {
      return this.makers[this.selectedMaker].image.url;
    }
  },
  created() {
    const { items } = this.slice;
    this.makers = items;
  },
  methods: {
    changeMaker(index) {
      this.selectedMaker = index;
    },
    isSelected(index) {
      return this.selectedMaker === index;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-container {
  padding: 30px;
  align-items: center;
}
.image-container {
  @include md {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  img {
    max-height: 450px;
    width: auto;
  }
}
.makers-container {
  height: 682px;
  border-radius: 5px;
  @include lg {
    height: auto;
  }
}
.option {
  cursor: pointer;
  margin: 0px 10%;
  padding-bottom: 15px;
  color: rgba($white, 0.45);
  @include lg {
    font-size: 20px;
  }
  .maker-title {
    font-weight: 400;
    font-size: 28px;
    margin: 5px 0;
  }
}
.option-border {
  margin-left: 10%;
  margin-right: 60%;
  border-bottom: 3px transparent;
}
.options {
  align-items: center;
  justify-content: center;
}
.selected {
  color: $white !important;
}
.selected-border {
  border-bottom: 3px solid $white !important;
}
.see-more-button {
  @include lg {
    margin-bottom: 30px;
  }
}
.makers-subtitle {
  font-size: 18px;
  color: $white;
  margin: 40px 0px;
  @include lg {
    font-size: 15px;
  }
}
</style>
